import { Col, Row, Space, Table, Tag, Typography, Divider } from 'antd';
import { stringDate, getFullName } from '../../../../util';
import { couponTypeDictionary } from '../../../../constants';
import { formatPrice } from '../../../../util/formatPrice';
import { RenderStatus } from '../../../uiComponents';
import './styles.css';

export const CouponModal = ({ data = {} }) => {
  const { Text } = Typography;

  const orderColumns = [
    {
      title: 'Orden',
      dataIndex: 'orderNumber',
      key: 'orderNumber',
    },
    {
      title: 'Fecha',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (created_at) => stringDate(created_at) || '-',
    },
    {
      title: 'Cliente',
      dataIndex: 'customer',
      key: 'customer',
      render: (customer) => <>{getFullName(customer)}</>,
    },
    {
      title: 'Sucursal',
      dataIndex: 'branch',
      key: 'branch',
      render: (branch) => branch?.name,
    },
    {
      title: 'Gerente',
      dataIndex: 'user',
      key: 'user',
      render: (user) => <>{getFullName(user)}</>,
    },
  ];

  const getItems = () => {
    const items = [];

    if (Array.isArray(data?.treatments) && data.treatments.length) {
      items.push(
        ...data.treatments.map((treatment) => ({
          id: `t-${treatment.id}`,
          name: `${treatment.name} (Tratamiento)`,
          price: treatment.price,
        }))
      );
    }

    if (Array.isArray(data?.products) && data.products.length) {
      items.push(
        ...data.products.map((product) => ({
          id: `p-${product.id}`,
          name: `${product.name} (Producto)`,
          price: product.salePrice,
        }))
      );
    }

    if (!items.length && data?.treatment) {
      items.push({
        id: `t-${data.treatment.id}`,
        name: `${data.treatment.name} (Tratamiento)`,
        price: data.treatment.price,
      });
    }

    if (!items.length && data?.product) {
      items.push({
        id: `p-${data.product.id}`,
        name: `${data.product.name} (Producto)`,
        price: data.product.salePrice,
      });
    }

    return items;
  };

  const items = getItems();

  const renderHorizontalTable = () => {
    if (!items.length) return null;
    const discount = data?.discount || 0;

    return (
      <div style={{ overflowX: 'auto', marginTop: 10 }}>
        <table className="custom-horizontal-table uniform-text">
          <tbody>
            <tr>
              <th>Nombre</th>
              {items.map((item) => (
                <td key={`name-${item.id}`}>{item.name}</td>
              ))}
            </tr>
            <tr>
              <th>Precio regular</th>
              {items.map((item) => (
                <td key={`price-${item.id}`}>{formatPrice(item.price)}</td>
              ))}
            </tr>
            <tr>
              <th>Precio con descuento ({discount}%)</th>
              {items.map((item) => {
                const finalPrice = item.price - item.price * (discount / 100);
                return (
                  <td key={`final-${item.id}`}>{formatPrice(finalPrice)}</td>
                );
              })}
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <>
      <Row className="row">
        <Col span={8}>
          <h4>Código</h4>
        </Col>
        <Col span={16}>{data?.code}</Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h4>Usos</h4>
        </Col>
        <Col span={16}>
          {data?.limit}
          <Text type="danger">{` - ${data?.used} usos`}</Text>
          <Text type="success">{` = ${
            data?.limit - data?.used
          } restante`}</Text>
        </Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h4>Usos por usuario</h4>
        </Col>
        <Col span={16}>{data?.useLimitByUser}</Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h4>Nombre</h4>
        </Col>
        <Col span={16}>{data?.name}</Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h4>Descripción</h4>
        </Col>
        <Col span={16}>{data?.description || '-'}</Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h4>Vigencia</h4>
        </Col>
        <Col span={16}>{stringDate(data?.expireDate)}</Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h4>Válido en</h4>
        </Col>
        <Col span={16}>
          <Space wrap>
            {data?.branches?.map((branch) => (
              <Tag key={`branch-${branch.name}`}>{branch.name}</Tag>
            ))}
          </Space>
        </Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h4>Tipo</h4>
        </Col>
        <Col span={16}>{couponTypeDictionary[data?.type]}</Col>
      </Row>

      <Divider />

      {renderHorizontalTable()}

      <Divider />

      <Row className="row">
        <Col span={8}>
          <h4>Status</h4>
        </Col>
        <Col span={16}>
          <RenderStatus data={data} />
        </Col>
      </Row>

      <Table
        pagination={{
          defaultPageSize: 3,
        }}
        dataSource={[...(data?.orders || []), ...(data?.cashOrders || [])]}
        columns={orderColumns}
        rowKey={(record) => record?.id || record?.orderNumber}
      />
    </>
  );
};
